if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				// document.querySelector('[data-js-site-cart-sidebar]').show();
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}
// cart image 
          document.addEventListener('DOMContentLoaded' , function(event){
             var targetNode = document.body;

            var config = { attributes: true, subtree: true };
        
            var callback = function(mutationsList) {
                mutationsList.forEach(function(mutation) {
                    
                    var slideCartElement = document.querySelector('.slidecarthq'); 
                    if (mutation.attributeName === 'class' && slideCartElement) {
                        if (slideCartElement.classList.contains('open')) {
                            // console.log("SlideCart is now open!");
                          const parentDivCart = document.querySelector('.slidecarthq .footer');
                          let childDiv = parentDivCart.querySelector('.footer-row-flex.flex');
                            if (childDiv) {
                                childDiv.parentElement.style.display = 'none';
                            }
                          if(!document.querySelector('.fire-image-subtotal-cs')){
                            let fireImage = document.createElement('strong');
                            fireImage.classList.add('fire-image-subtotal-cs');
                            let image = document.createElement('img');
                            image.src = 'https://cdn.shopify.com/s/files/1/0637/9716/6216/files/bold-flavor-icon.png?v=1719247734';
                            fireImage.append(image);
                            parentDivCart.querySelector('.footer-row').before(fireImage);
                          }
                        }
                    }
                });
            };
        
            var observer = new MutationObserver(callback);
        
            observer.observe(targetNode, config);
            // console.log(document.querySelector('.slidecarthq .footer'),'cart');
            const cartIcons = document.querySelectorAll('.c-icon-nav[href="/cart"]');
            cartIcons.forEach(function(cartIcon) {
              cartIcon.onclick = () => {
                const parentDivCart = document.querySelector('.slidecarthq .footer');
                let childDiv = parentDivCart.querySelector('.footer-row-flex.flex');
                  if (childDiv) {
                    // let fireImage = document.createElement('strong');
                    // fireImage.classList.add('fire-image-subtotal-cs');
                    // let image = document.createElement('img');
                    // image.src = 'https://cdn.shopify.com/s/files/1/0637/9716/6216/files/bold-flavor-icon.png?v=1719247734';
                    // fireImage.append(image);
                    // childDiv.parentElement.parentElement.append(fireImage);
                    // childDiv.parentElement.style.display = 'none';
                  }
                }
              })
          })
function updateCartCount() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const uniqueItemCount = data.items.length;
            document.querySelector('.cartCount').textContent = uniqueItemCount;
            document.querySelector('.cartCount2').textContent = uniqueItemCount;
        })
        .catch(error => console.error('Error updating cart count:', error));
}
document.addEventListener('DOMContentLoaded', updateCartCount);



const waitForElement = setInterval(() => {
    const targetDiv = document.querySelector('.items');
    const parentDiv = document.querySelector('.slidecarthq'); 

    if (targetDiv) {
        // console.log('Item found');
        clearInterval(waitForElement);

        // const updateCartCount = () => {
        //     const childCount = targetDiv ? targetDiv.childElementCount : 0;
        //     console.log(`Current child count: ${childCount}`);
        //     document.querySelector('.cart-count').textContent = childCount > 0 ? childCount : '0';
        // };
updateCartCount();
        const callback = function(mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // Check if .items has been removed
                    const targetDivExists = document.querySelector('.items');
                    if (!targetDivExists) {
                        // console.log('.items div removed, updating cart count to 0');
                        document.querySelector('.cartCount').textContent = '0';
                        document.querySelector('.cartCount2').textContent = '0';
                        // observer.disconnect(); // Stop observing once targetDiv is removed
                        return;
                    }
                }
                    updateCartCount();
            }
        };

        // Initial cart count update
        updateCartCount();

        // Create a MutationObserver instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Define the configuration for the observer (observe child nodes and subtree)
        const config = { childList: true, subtree: true };

        // Start observing the parent div for changes, including when .items is removed
        observer.observe(parentDiv, config);
    }
}, 500);


